import React from 'react'
import { BsrsGrid, Column, DateCell, DateFilterCell, fileDownloadCell } from '@/components/BsrsGrid'
import Resx from '@/components/Resx'
import { Main, MainTop, MainTopTitle, MainTopLeft, MainBody } from '@/components/Layout'
import context from '@/context'
import { DataLoader } from '@/components/dataLoader'
import LoadingIndicator from '@/components/LoadingIndicator'
import IndividualDetail from '@/components/userProfile/individualDetail'
import { localized } from '@/decorators/localized'
import { WhiteBox } from '@/components/Layout/Layout.Box'

@localized()
class CbsReportList extends React.Component {
  render () {
    const { localize } = this.props
    const individualId = this.props.match.params.id
    const downloadAction = context.api.individualService.download
    return (
      <Main>
        <MainTop>
          <MainTopTitle backUrl={`/individuals/${individualId}`}>
            <Resx name='Individuals.CbsReportsHistoryTitle' />
          </MainTopTitle>
          <MainTopLeft />
        </MainTop>

        <MainBody>
          <DataLoader
            dataSource={() => context.api.individualService.getIndividualById(individualId)}
            render={({ data, loading }) => (
              loading
                ? <LoadingIndicator />
                : <IndividualDetail individual={data} headerText={localize('UserProfile.Individual')} />
            )} />
          <WhiteBox>
            <BsrsGrid
              dataSource={request => context.api.individualService.getCbsReportsTable(individualId, request)}
              defaultSort={[{ field: 'creationTime', dir: 'desc' }]}>
              <Column field='name' title={localize('Common.Name')} width='250px' />
              <Column field='length' title={localize('Common.Length')} filter='numeric' width='150px' />
              <Column field='creationTime' title={localize('Common.CreationTime')} filter='date' filterCell={DateFilterCell} cell={DateCell} width='150px' />
              <Column field='id' title={localize('Common.Download')} cell={fileDownloadCell({ downloadAction, localize, isChangeRequest: false })} filterable={false} width='110px' />
            </BsrsGrid>
          </WhiteBox>
        </MainBody>
      </Main>
    )
  }
}

export {
  CbsReportList
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/individuals/cbsReports/list.js